// extracted by mini-css-extract-plugin
export var externalLink = "_ba-0";
export var internalLinkLabel = "_ba-1";